/**
 * The cursor for "this can only slide along its wall".
 *
 * A door, window or opening never leaves its wall, so the four-way `move`
 * cursor over-promised: it reads as free movement. A two-way resize
 * arrow snapped to the wall's on-screen angle says exactly what a drag
 * will do. The plan draws +X to the right and +Z DOWN, so a direction's
 * screen angle is `atan2(z, x)` with no flip.
 *
 * @param {[number, number] | {x: number, z: number}} dir - plan direction
 * @returns {'ew-resize' | 'ns-resize' | 'nesw-resize' | 'nwse-resize'}
 */
export const alongWallCursor = (dir) => {
  const x = Array.isArray(dir) ? dir[0] : (dir?.x ?? 1);
  const z = Array.isArray(dir) ? dir[1] : (dir?.z ?? 0);
  // Fold to [0, 180): a two-way cursor has no sign.
  let deg = (Math.atan2(z, x) * 180) / Math.PI;
  if (deg < 0) deg += 180;
  const step = Math.round(deg / 45) % 4;
  // 0° = along screen X; 45° = down-right (nwse); 90° = vertical;
  // 135° = down-left (nesw).
  return ['ew-resize', 'nwse-resize', 'ns-resize', 'nesw-resize'][step];
};
